// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Tv15","rootSuccess":"CompleteLink_rootSuccess__3KYNv","rootFailure":"CompleteLink_rootFailure__1QUU1","isDisabled":"CompleteLink_isDisabled__3FZTl"};